module.exports = __webpack_public_path__ + "img/list-selected.079dac33.svg";